// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Kb6V","col":"styles_col__11TrQ"};